import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { ToastController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { alertCircle } from 'ionicons/icons';

const isBigError = (status: number): boolean => {
  if (status > 399 && status < 500 && status !== 404) {
    return true;
  } else if (status > 499 && status < 600) {
    return true;
  }

  return false;
};

// TODO: discuss/fix/test translations !!

export class Ad6ErrorHandler implements ErrorHandler {
  private toastController = inject(ToastController);
  private translateService = inject(TranslateService);

  constructor() {
    addIcons({ alertCircle });
  }

  handleError(error: object): void {
    if (!environment.production) {
      console.error('Ad6ErrorHandler.error', error);
    }

    const key =
      error instanceof HttpErrorResponse && error.status === 0
        ? 'connection'
        : 'general';

    if (error instanceof HttpErrorResponse && isBigError(error.status)) {
      const toast = this.translateService.instant(
        `error.toast.${key}`,
      ) as string;

      void this.showToast(toast);
    }
  }

  private async showToast(message: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      color: 'danger',
      icon: 'alert-circle',
      duration: 5000,
      buttons: [
        {
          text: this.translateService.instant('button.close') as string,
          role: 'cancel',
        },
      ],
    });

    await toast.present();
  }
}
